<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-date-picker
          class="filter-item dp"
          v-model="dateRange"
          @change="handleDateRangeChange"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <auth-select :isEdit="true" type="select" :data-source="[{value:'TL1000',label:'TL1000'},{value:'TL2000',label:'TL2000'}]" v-model="listQuery.domain" :value="listQuery.domain" class="filter-item"></auth-select>
        <auth-select :isEdit="true" type="select" :data-source="'UserEventType'" v-model="listQuery.event" :value="listQuery.event" class="filter-item"></auth-select>
        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" class="filter-item" :placeholder="'关键字'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table
          style="height:calc(100% - 60px)"
          ref="mainTable"
          :select-type="''"
          :table-fields="headerList"
          :data="list"
          :v-loading="listLoading"
        ></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>
<script>
import * as userEvents from '@/api/userEvents'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import extend from '@/extensions/common.js'
import AuthSelect from '@/components/Base/AuthSelect'
import AuthTable from '../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
export default {
  name: 'userEvent',
  components: { Sticky, permissionBtn, Pagination, AuthTable, AuthSelect},
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      dateRange:[],
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
        domain:undefined,
        event:undefined,
        start:undefined,
        end:undefined
      },
    }
  },
  created() {
    this.headerList = [
      new ColumnDefine('domain', 'Domain', true, true, '', '', 'string', 'varchar', 'domain'),
      new ColumnDefine('uid', 'Uid', true, true, '', '', 'string', 'varchar', 'Uid'),
      new ColumnDefine('account', '对讲账号', true, true, '', '', 'string', 'varchar', 'Account'),
      new ColumnDefine('event', '事件', true, true, 'select', 'UserEventType', 'string', 'varchar', 'Event'),
      new ColumnDefine('eventTime', '时间', true, true, '', '', 'DateTime', 'datetime', 'EventTime'),
      new ColumnDefine('id', 'ID', false, false, '', '', 'bigint', 'bigint', 'Id'),
     
    ]
    this.getList()
  },
  methods: {
    handleDateRangeChange(value){
      if(value && value.length == 2){
        this.listQuery.start = value[0]
        this.listQuery.end = value[1]
      }
    }, 
    onBtnClicked: function(domId,callback) {
      switch (domId) {
        case 'btnExport':
            this.$refs.mainTable.exportExcel('资源文件',callback)
            break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      userEvents.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
  },
}
</script>
<style scoped>
.dialog-mini .el-select {
  width: 100%;
}

.dp {
  height:28px;
  /deep/ .el-input__inner{
    height:28px;
  }
}
</style>
